import { animate, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { LoadingService } from '@shared/components/loading/loading.service';

@Component({
  selector: 'app-loading',
  imports: [NgIf, FontAwesomeModule],
  template: `
    <div *ngIf="isLoading()" @fadeInOut class="fixed inset-0 bg-gray-800/50 flex justify-center items-center z-50">
      <div class="bg-white p-4 rounded-lg shadow-lg flex items-center gap-2">
        <fa-icon [icon]="spinnerIcon" class="animate-spin text-primary text-3xl"></fa-icon>
        <span class="text-gray-700 font-medium">Cargando...</span>
      </div>
    </div>
  `,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms ease-out', style({ opacity: 1 }))]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);
  spinnerIcon = faSpinner;
  isLoading = this.loadingService.isLoading;
}
